import { useMemo, useState } from 'react';
import { formatCurrency } from '../ui';
import { estimateReplacementCostForSalary } from '../../utils/employeeReplacementCost';

const SALARY_MIN = 15_000;
const SALARY_MAX = 500_000;
const SALARY_DEFAULT = 75_000;
const SALARY_STEP = 1_000;

function salaryProgress(salary) {
  return ((salary - SALARY_MIN) / (SALARY_MAX - SALARY_MIN)) * 100;
}

export default function ReplacementCostExplorer() {
  const [salary, setSalary] = useState(SALARY_DEFAULT);

  const replacementCost = useMemo(
    () => estimateReplacementCostForSalary(salary),
    [salary],
  );

  const fillPct = salaryProgress(salary);

  return (
    <div className="replacement-cost-explorer">
      <div className="replacement-cost-explorer__glow" aria-hidden="true" />

      <div className="replacement-cost-explorer__metrics">
        <div className="replacement-cost-explorer__metric">
          <span className="replacement-cost-explorer__label">Annual salary</span>
          <span className="replacement-cost-explorer__value" aria-live="polite">
            {formatCurrency(salary)}
          </span>
        </div>
        <div className="replacement-cost-explorer__divider" aria-hidden="true" />
        <div className="replacement-cost-explorer__metric replacement-cost-explorer__metric--accent">
          <span className="replacement-cost-explorer__label">Est. replacement cost</span>
          <span className="replacement-cost-explorer__value" aria-live="polite">
            {formatCurrency(replacementCost)}
          </span>
        </div>
      </div>

      <div className="replacement-cost-explorer__slider-wrap">
        <label htmlFor="about-replacement-salary" className="replacement-cost-explorer__slider-label">
          Drag to explore
        </label>
        <input
          id="about-replacement-salary"
          type="range"
          className="replacement-cost-explorer__range"
          min={SALARY_MIN}
          max={SALARY_MAX}
          step={SALARY_STEP}
          value={salary}
          onChange={(e) => setSalary(Number(e.target.value))}
          style={{ '--range-fill': `${fillPct}%` }}
          aria-valuemin={SALARY_MIN}
          aria-valuemax={SALARY_MAX}
          aria-valuenow={salary}
          aria-valuetext={formatCurrency(salary)}
        />
        <div className="replacement-cost-explorer__range-labels">
          <span>{formatCurrency(SALARY_MIN)}</span>
          <span>{formatCurrency(SALARY_MAX)}+</span>
        </div>
      </div>

      <p className="replacement-cost-explorer__footnote">
        Mid-level role estimate — recruiting, onboarding, vacancy, and productivity loss.
      </p>
    </div>
  );
}
